"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function GroupMailMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__group-mail-multitone-filled__clip0_22973_2679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__group-mail-multitone-filled__paint0_linear_22973_2679)",
    d: "M9.454 0h-.04A2.61 2.61 0 019.1.068l-.124.023A758.675 758.675 0 007.1.454L5.959.675a2803.665 2803.665 0 01-2.147.416l-1.001.193-1.4.271-.761.148-.122.023c-.123.024-.247.049-.37.07-.044.008-.062.026-.054.069V2.817l-.001 11.19c0 .06.012.084.077.098 1.025.212 2.05.427 3.074.642l.551.116 1.282.27 1.905.399 2.2.46c.046.01.093.008.14.007.028-.001.056-.002.083 0 .028 0 .034-.014.033-.037v-.044-.06V.091.068C9.444.045 9.443.022 9.453 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B64B5",
    d: "M15.899 12.144c-.024.033-.027.073-.042.109-.125.304-.363.451-.681.485-.05.005-.101.004-.152.004-1.652 0-3.305 0-4.958.002-.064 0-.084-.011-.084-.081.002-1.369.002-2.737.002-4.105v-.064c.03-.008.043.013.06.025l.919.63c.122.084.23.085.355.002.726-.484 1.452-.97 2.178-1.453.781-.52 1.563-1.04 2.345-1.558.018-.012.032-.032.058-.028v6.033zM15.899 4.845c-.047.008-.08.042-.117.067a4864.279 4864.279 0 00-4.516 3.045c-.086.058-.16.058-.247.002a83.823 83.823 0 00-.982-.618c-.041-.026-.054-.053-.054-.1.001-.999.002-1.997 0-2.995 0-.067.019-.078.08-.078 1.734.002 3.468.001 5.202.001.285 0 .496.141.61.406.006.016.015.03.024.045v.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "evenodd",
    d: "M7.406 4.605a.5.5 0 01-.416.572l-4.916.776a.5.5 0 11-.156-.987l4.916-.777a.5.5 0 01.572.416zM7.401 7.427a.5.5 0 01-.46.538l-4.906.38a.5.5 0 11-.078-.996l4.907-.381a.5.5 0 01.537.46zM1.496 10.271a.5.5 0 01.5-.5h3.041a.5.5 0 010 1h-3.04a.5.5 0 01-.5-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004C84",
    d: "M9.982 4.168h.59v3.511l-.59-.373V4.168zM9.982 8.472l.59.409v3.863h-.59V8.472z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__group-mail-multitone-filled__paint0_linear_22973_2679",
    x1: 0.101,
    x2: 9.453,
    y1: 8.349,
    y2: 8.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CA7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2279D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__group-mail-multitone-filled__clip0_22973_2679"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

GroupMailMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
GroupMailMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = GroupMailMultitoneFilled;
exports["default"] = _default;